/**
 * Class to get icons
 * it will be used to search trough the "categories" array of the app conf
 */
export default class IconUtil {
  constructor(categories) {
    this.categories = categories;
  }

  /**
   * Returns the symbol to the given id
   * @param {id of the category} id
   * @return Icon name, can be an mdi icon or an link to another icon
   *         if no icon is found, undefined will used as fallback value
   */
  getIconById(id) {
    let symbol;
    this.categories.forEach((item) => {
      if (item.id === id) {
        if ('mdiIcon' in item) {
          symbol = { icon: item.mdiIcon, useAsMdi: true };
        } else {
          symbol = { icon: item.symbol, useAsMdi: false };
        }
      }
    });
    if (!symbol) {
      return {
        icon: 'mdi-help',
        useAsMdi: true,
      };
    }
    return symbol;
  }
}
